/* global $ */
import React from 'react';
import cn from 'classnames';

function onFocus(e) {
  $(e.target).closest('.form-field').find('label').addClass('active');
}

function onBlur(e) {
  if (!e.target.value) {
    $(e.target).closest('.form-field').find('label').removeClass("active");
  }
}

export default ({id, label, className, required, placeholder, multiline, onChange, value, isLarge = true, rows, maxLength, inputType, children}) => {

  const valueComp = React.createElement(multiline ? 'textarea' : 'input', {
    id,
    defaultValue: value,
    placeholder,
    onChange,
    required,
    className: cn('form-control', { 'form-control-lg': isLarge }),
    onFocus,
    onBlur,
    rows,
    maxLength,
    type: inputType
  });


  return (
    <div className={cn('form-field', className, 'form-group')}>
      { valueComp }
      { children }
      <label className="" htmlFor={id}>{label}</label>
    </div>
  )
};


// WEBPACK FOOTER //
// ./src/components/common/FormField.js